import { useQuery } from '@tanstack/react-query'
import { getYouTubeVideoUserTranscripts } from '@/services/youtube.service'

export const YOUTUBE_USER_TRANSCRIPTS_QUERY_KEY = 'youtube-user-transcripts'

/**
 * useYouTubeVideoTranscripts — loads all source='user' transcripts for a saved video.
 *
 * Used in two roles in VideoPlayer:
 *  1. On mount (enabled: !!videoId) — determines whether to show the download button.
 *  2. On modal open — provides data to TranscriptDownloadModal (same cached result; no re-fetch).
 *
 * The hook intentionally uses TanStack Query (unlike the per-segment caption hooks) because
 * this is an idempotent read that benefits from caching and does NOT need user-initiation
 * semantics — it is safe to auto-fetch on player mount.
 */
export const useYouTubeVideoTranscripts = (videoId: string) => {
  return useQuery({
    queryKey: [YOUTUBE_USER_TRANSCRIPTS_QUERY_KEY, videoId],
    queryFn: () => getYouTubeVideoUserTranscripts(videoId),
    select: (data) => data.segments,
    enabled: !!videoId,
    staleTime: 30_000,
  })
}
